import { render, staticRenderFns } from "./online-study.vue?vue&type=template&id=46701732&scoped=true&"
import script from "./online-study.vue?vue&type=script&lang=ts&"
export * from "./online-study.vue?vue&type=script&lang=ts&"
import style0 from "./online-study.vue?vue&type=style&index=0&id=46701732&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46701732",
  null
  
)

export default component.exports